/**
 * Returns a list with auxiliaries for the Spanish passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default [
	"bli",
	"blir",
	"ble ",
	"blei",
	"blitt",
	"bli",
	"blivende",
	"blis",
	"er",
];
